<template>
  <div class="social-media">
    <a @click="userClickedOnGithub()" href="https://github.com/nikos-pertsilis" class="media-item" target="_blank">
      <img src="../../../assets/img/icons/socialMedia/ic_github.png" class="media-icon" alt="github icon"/>
    </a>
    <a @click="userClickedOnLinkedIn()" href="https://www.linkedin.com/in/nikolaos-pertsilis/" class="media-item" target="_blank">
      <img src="../../../assets/img/icons/socialMedia/ic_linked_circle.svg" class="media-icon" alt="linkedIn icon"/>
    </a>
  </div>
</template>

<script>
  import {userClickedOnLinkedIn, userClickedOnGithub} from "@/setup/firebase/firebaseAnalytics";

  export default {
    name: "SocialMedia",
    data:() => ({
      userClickedOnLinkedIn,
      userClickedOnGithub
    })
  }
</script>

<style scoped lang="scss">
  @import "../../../assets/css/base.mixins";
  @import "../../../assets/css/base.variables";

  .social-media {
    @include position-elevation(fixed, $bottom: 25px, $left: 20px, $elevation: 100);
    align-items: center;
    background-color: var(--brown-main);
    border-radius: 8px;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    opacity: 0.7;
    padding: 10px;

    .media-item {
      &:first-child {
        margin-bottom: 15px;
      }
    }

    .media-icon {
      height: 25px;
      opacity: 0.6;
      width: 25px;

      &:hover {
        cursor: pointer;
        opacity: 1;
      }
    }
  }

  @media screen and (min-width: $screen-lg) {
    .social-media {

    }

  }
</style>
